var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    height: "60px",
    width: "60px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#576574"
    },
    d: "M218.193,0C161.421,0,115.4,46.02,115.4,102.792v40.677c6.87-6.368,16.643-9.829,26.184-8.555v-5.122 c0-4.072,3.477-7.288,7.508-6.983c39.742,2.855,80.188-9.774,110.77-29.751c2.855-1.866,6.635-1.402,8.955,1.092 c26.145,28.103,25.987,27.016,25.987,30.684v10.058c10.458-1.567,19.734,1.664,26.179,7.656v-39.757 C320.984,46.02,274.965,0,218.193,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E4B5A"
    },
    d: "M142.991,102.792c0-52.09,38.753-95.1,88.996-101.844C227.473,0.342,222.874,0,218.193,0 c-56.772,0-102.791,46.02-102.791,102.792v40.678c6.87-6.368,16.643-9.829,26.184-8.555v-5.122c0-1.581,0.529-3.029,1.406-4.197 L142.991,102.792L142.991,102.792z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BB88"
    },
    d: "M293.443,130.808v56.309c0,0.61-0.032,1.213-0.047,1.821c19.927,3.017,35.533-11.381,35.533-29.063 C328.929,142.158,313.31,127.83,293.443,130.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BB88"
    },
    d: "M142.947,187.117V130.83c-17.348-2.317-35.487,10.997-35.487,29.046 c0,17.659,15.572,32.083,35.532,29.062C142.977,188.33,142.947,187.725,142.947,187.117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3A76F"
    },
    d: "M318.372,137.368c-6.368-5.283-15.129-8.029-24.929-6.561v56.309c0,0.61-0.032,1.213-0.046,1.821 c9.829,1.488,18.603-1.266,24.975-6.557V137.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3A76F"
    },
    d: "M142.947,182.385c-6.549-5.438-10.558-13.555-10.558-22.51c0-8.713,4.234-16.315,10.558-21.595 v-7.451c-17.348-2.317-35.487,10.997-35.487,29.046c0,17.659,15.571,32.083,35.531,29.062c-0.015-0.607-0.044-1.213-0.044-1.821 L142.947,182.385L142.947,182.385z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BB88"
    },
    d: "M219.288,261.271c-16.607,0-31.201-4.559-43.137-12.186v40.342l42.952,53.018l42.952-53.018v-41.479 C249.887,256.341,235.155,261.271,219.288,261.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3A76F"
    },
    d: "M203.659,259.85c-10.24-1.9-19.478-5.634-27.508-10.765v40.342l27.508,33.954V259.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EAF8"
    },
    d: "M375.684,330.709l-113.628-44.005l-42.951,53.018l-42.953-53.018l-113.51,44.005 c0,0-42.027,17.278-42.027,65.187v106.328c0,5.399,4.377,9.776,9.776,9.776h377.626c5.352,0,9.691-4.339,9.691-9.691V395.896 C417.71,347.986,375.684,330.709,375.684,330.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M48.123,502.224V383.517c0-32.87,19.781-51.318,32.2-59.664l-17.681,6.855 c0,0-42.027,17.277-42.027,65.187v106.328c0,5.399,4.377,9.776,9.776,9.776h27.508C52.5,512,48.123,507.623,48.123,502.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D1A5"
    },
    d: "M268.818,91.427c-2.32-2.494-6.101-2.957-8.956-1.092c-30.581,19.977-71.027,32.606-110.77,29.751 c-4.031-0.305-7.508,2.911-7.508,6.983v61.409c0,39.468,30.925,75.516,77.703,75.516c41.64,0,75.517-33.877,75.517-75.516v-66.367 C294.804,118.443,294.962,119.53,268.818,91.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BB88"
    },
    d: "M169.092,188.479v-68.233c-6.653,0.354-13.336,0.32-20-0.159c-4.031-0.306-7.508,2.911-7.508,6.983 v61.409c0,39.468,30.925,75.516,77.703,75.516c4.316,0,8.541-0.383,12.661-1.082C196.318,256.869,169.092,225.802,169.092,188.479z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M270.964,366.964l32.119-64.371l-41.029-15.89l-42.952,53.018l41.877,29.741 C264.369,371.87,269.107,370.684,270.964,366.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M167.301,366.964l-32.119-64.371l41.028-15.89l42.952,53.018l-41.877,29.741 C173.896,371.87,169.159,370.684,167.301,366.964z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE5253"
    },
    d: "M219.159,339.758v-0.037l-0.026,0.018l-0.026-0.018v0.037l-30.458,21.632l14.397,21.668 c11.615,0,20.56,0,32.174,0l14.397-21.668L219.159,339.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6B6B"
    },
    d: "M181.221,512h75.822l-21.824-128.942c-11.615,0-20.56,0-32.174,0L181.221,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D83941"
    },
    d: "M234.374,350.565l-15.216-10.807v-0.037l-0.026,0.018l-0.026-0.018v0.037l-30.458,21.632 l14.397,21.669c11.202,0,19.902,0,30.484,0l-11.821-17.792c-1.435-2.16-0.896-5.07,1.219-6.572L234.374,350.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE5253"
    },
    d: "M203.046,383.058L181.221,512h30.484l21.824-128.942C222.901,383.058,214.29,383.058,203.046,383.058 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DCE5"
    },
    d: "M100.872,512v-99.742c0-4.267-3.459-7.727-7.727-7.727s-7.727,3.459-7.727,7.727V512H100.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#54A0FF"
    },
    d: "M266.477,447.48c-4.484,0-8.119,3.635-8.119,8.119V512h60.318v-64.52H266.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338DEF"
    },
    d: "M287.081,447.48h-20.605c-4.484,0-8.118,3.635-8.118,8.119L258.357,512h20.605v-56.401 C278.962,451.115,282.597,447.48,287.081,447.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BA8B"
    },
    d: "M345.743,382.96c0,0-12.394,0-21.013,0c-4.484,0-8.116,3.635-8.116,8.119V512h60.317V382.96H345.743z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11AA7B"
    },
    d: "M345.335,382.96c-2.191,0-12.902,0-20.605,0c-4.484,0-8.116,3.635-8.116,8.119V512h20.605V391.079 C337.219,386.595,340.852,382.96,345.335,382.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FECA57"
    },
    d: "M404,318.44h-21.01c-4.484,0-8.119,3.635-8.119,8.119v56.401l0,0V512h60.317V382.96v-64.52H404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B537"
    },
    d: "M395.385,382.96v-56.401c0-4.484,3.635-8.119,8.118-8.119H382.99c-4.484,0-8.119,3.635-8.119,8.119 v56.401l0,0V512h20.513V382.96H395.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE5253"
    },
    d: "M483.488,253.92h-21.232c0,0-12.394,0-21.012,0c-4.484,0-8.116,3.635-8.116,8.119V512h48.701 c5.278,0,9.556-4.278,9.556-9.556V261.817C491.385,257.456,487.85,253.92,483.488,253.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D83941"
    },
    d: "M461.761,253.92c5.925,0,13.635,0,17.875,0h-17.379c0,0-12.393,0-21.012,0 c-4.484,0-8.116,3.635-8.116,8.119V512h20.516V262.039C453.645,257.555,457.277,253.92,461.761,253.92z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.2eda4b773665ef84926d2ea0a325ad14.svg";
export { ForwardRef as ReactComponent };